import { PageLoader } from "#/components/ui/page-loader";
import { TableErrorState } from "#/components/ui/table-error-state";
import { useLearnPosts } from "../hooks/use-learn-posts";
import { useLearnSearch } from "../hooks/use-learn-search";
import { LearnHero } from "./learn-hero";
import { LearnSearchInput } from "./learn-search-input";
import { LearnSearchResults } from "./learn-search-results";
import { LearnSections } from "./learn-sections";

export function LearnHubPage() {
	const postsQuery = useLearnPosts();
	const search = useLearnSearch(postsQuery.data ?? []);

	return (
		<div className="mx-auto max-w-3xl p-4 pt-10 pb-16">
			<LearnHero />
			<LearnSearchInput value={search.query} onChange={search.setQuery} />

			{postsQuery.isPending ? (
				<PageLoader />
			) : postsQuery.isError ? (
				<TableErrorState onRetry={() => postsQuery.refetch()} />
			) : search.isSearching ? (
				<LearnSearchResults
					matches={search.matches}
					hasResults={search.hasResults}
				/>
			) : (
				<LearnSections posts={postsQuery.data} />
			)}
		</div>
	);
}
